import styled from 'styled-components';

const StyledIframe = styled.iframe`
  height: 80vh;
  width: 100%;
  max-width: 100%;
  border: none;
`;

interface PdfViewer {
  base64String: string;
}

export const PdfViewer = ({ base64String }: PdfViewer) => {
  const pdfData = `data:application/pdf;base64,${base64String}`;

  return <StyledIframe title="Delivery receipt" src={pdfData} />;
};
